"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StudySettingTable = void 0;
const throttle_1 = __importDefault(require("lodash/throttle"));
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const styled_components_1 = __importStar(require("styled-components"));
const Colors_1 = require("../../../../../Colors");
const GlobalStateProvider_1 = require("../../../../../GlobalStateProvider");
const common_1 = require("../../../../../common");
const server_1 = require("../../../../../server");
const popup_1 = require("../../../../base/popup");
const AttachContentButton_1 = require("../../../DSTS006/DSTS006_List_Child/AttachContentButton");
const ContentTable_1 = require("../../../DSTS006/DSTS006_List_Child/ContentTable");
const TestSetting_1 = require("./TestSetting");
const StudySettingStyle = styled_components_1.default.div `
	width: 100%;
	display: flex;
	flex-direction: column;

	.underbar_line {
		cursor: pointer;
		color: var(--color-accent, #e7424c);
		text-align: left;
		font-family: 'Noto Sans KR', sans-serif;
		font-size: 14px;
		line-height: 28px;
		font-weight: 400;
		text-decoration: underline;
		position: relative;
		width: 38px;
		text-overflow: ellipsis;
		overflow: hidden;
		white-space: nowrap;
	}

	${props => (props.$isMobile ? mobileStyles : desktopStyles)}
`;
const mobileStyles = (0, styled_components_1.css) `
	flex: 1;
	height: 100%;
	gap: 6px;

	.no-question-wrap {
		display: flex;
		flex-direction: column;
		gap: 0px;
		align-items: flex-start;
		justify-content: flex-start;
		align-self: stretch;
		flex-shrink: 0;
		position: relative;
		width: 100%;
		height: 100%;

		.fext-field {
			display: flex;
			flex-direction: column;
			gap: 8px;
			align-items: center;
			justify-content: center;
			flex-shrink: 0;
			position: relative;

			p {
				color: var(--color-grey, #666666);
				text-align: left;
				font-family: var(--b1-font-family, 'Noto Sans KR', sans-serif);
				font-size: var(--b1-font-size, 20px);
				line-height: var(--b1-line-height, 42px);
				font-weight: var(--b1-font-weight, 400);
				position: relative;
				display: flex;
				align-items: center;
				justify-content: flex-start;
			}
		}
	}
	.live-list-002 {
		display: flex;
		flex-direction: column;
		gap: 0px;
		align-items: flex-start;
		justify-content: flex-start;
		flex-shrink: 0;
		position: relative;
		overflow: hidden;
		flex: 1;
		overflow: hidden;
	}
	.scroll-content {
		display: flex;
		flex-direction: column;
		gap: 0px;
		align-items: flex-start;
		justify-content: flex-start;
		flex: 1;
		position: relative;
		overflow-y: auto;
	}

	.item {
		border-style: solid;
		border-color: var(--color-silver, #f3f4f8);
		border-width: 1px 0px 0px 0px;
		padding: 12px 0px 12px 0px;
		display: flex;
		flex-direction: row;
		gap: 4px;
		align-items: center;
		justify-content: space-between;
		align-self: stretch;
		flex-shrink: 0;
		position: relative;

		color: var(--color-black, #101010);
		text-align: left;
		font-family: 'Noto Sans KR', sans-serif;
		font-size: 14px;
		line-height: 150%;
		letter-spacing: -0.02em;
		font-weight: 400;
		position: relative;
		flex: 1;
		text-overflow: ellipsis;
		overflow: hidden;
		white-space: nowrap;

		&:nth-child(1) {
			border-width: 0px;
		}

		&:nth-last-child(1) {
			border-width: 0px;
		}
	}

	.bold {
		color: var(--color-black, #101010);
		text-align: left;
		font-family: 'Noto Sans KR', sans-serif;
		font-size: 14px;
		line-height: 150%;
		letter-spacing: -0.02em;
		font-weight: 700;
		position: relative;
		align-self: stretch;
		text-overflow: ellipsis;
		overflow: hidden;
		white-space: nowrap;
	}

	.underbar_line {
		text-align: end;
		width: 100%;
	}

	.btn-container {
		width: 100%;
		padding-bottom: 4px;
		button {
			flex: 1;
		}
		label {
			display: flex;
			flex: 1;
		}
	}
`;
const desktopStyles = (0, styled_components_1.css) `
	flex: 1;
	height: 100%;
	min-width: 320px;
	gap: 13px;

	.no-question-wrap {
		display: flex;
		flex-direction: column;
		gap: 0px;
		align-items: flex-start;
		justify-content: flex-start;
		align-self: stretch;
		flex-shrink: 0;
		position: relative;
		width: 100%;
		height: 100%;

		.fext-field {
			display: flex;
			flex-direction: column;
			gap: 8px;
			align-items: center;
			justify-content: center;
			flex-shrink: 0;
			position: relative;

			p {
				color: var(--color-grey, #666666);
				text-align: left;
				font-family: var(--b1-font-family, 'Noto Sans KR', sans-serif);
				font-size: var(--b1-font-size, 20px);
				line-height: var(--b1-line-height, 42px);
				font-weight: var(--b1-font-weight, 400);
				position: relative;
				display: flex;
				align-items: center;
				justify-content: flex-start;
			}
		}
	}

	.live-list-002 {
		display: flex;
		flex-direction: column;
		gap: 0px;
		align-items: flex-start;
		justify-content: flex-start;
		flex-shrink: 0;
		position: relative;
		overflow: hidden;
		flex: 1;
		overflow: hidden;
	}

	.table-header {
		background: var(--color-silver, #f3f4f8);
		border-style: solid;
		border-color: var(--color-grey-w, #b6bac0);
		border-width: 1px 0px 0px 0px;
		padding: 10px 16px 10px 16px;
		display: flex;
		flex-direction: row;
		gap: 20px;
		align-items: center;
		justify-content: flex-start;
		flex-shrink: 0;
		position: relative;

		color: var(--color-grey, #666666);
		text-align: left;
		font-family: var(--b3-font-family, 'Noto Sans KR', sans-serif);
		font-size: var(--b3-font-size, 16px);
		line-height: var(--b3-line-height, 32px);
		font-weight: var(--b3-font-weight, 400);
	}

	.scroll-content {
		display: flex;
		flex-direction: column;
		gap: 0px;
		align-items: flex-start;
		justify-content: flex-start;
		flex: 1;
		position: relative;
		overflow-y: auto;
	}

	.item {
		padding: 8px 16px 8px 16px;
		display: flex;
		flex-direction: row;
		gap: 20px;
		align-items: center;
		justify-content: flex-start;
		flex-shrink: 0;
		position: relative;

		color: var(--color-black, #101010);
		text-align: left;
		font-family: var(--b4-font-family, 'Noto Sans KR', sans-serif);
		font-size: var(--b4-font-size, 14px);
		line-height: var(--b4-line-height, 28px);
		font-weight: var(--b4-font-weight, 400);
		position: relative;
		text-overflow: ellipsis;
		overflow: hidden;
		white-space: nowrap;
	}
`;
exports.StudySettingTable = react_1.default.memo(({ isDetail, isModify, mode, background = [], initItem, testData = [], setTestData, setItem, setBackground, }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const { isMobile, isDesktop } = (0, GlobalStateProvider_1.useGlobalState)();
    const [isUploading, setIsUploading] = (0, react_1.useState)(false);
    const [page, setPage] = (0, react_1.useState)(0);
    // const [testData, setTestData] = useState<ContentProps[]>([]);
    const [totalCount, setTotalCount] = (0, react_1.useState)(0);
    const [count, setCount] = (0, react_1.useState)(10);
    const { headTitleList, tableReadDataKeys } = react_1.default.useMemo(() => {
        // [자료명, 비고] : 예약 페이지
        // [자료명] : 상세보기 페이지
        const headTitleList = [
            { title: 'dataName', space: 2, sort: false, maxWidth: 200 },
            { title: 'type', space: 1, sort: false },
            ...(isDetail ? [] : [{ title: 'etc', space: 1, sort: false }]),
        ];
        const tableReadDataKeys = [
            { title: 'link', space: 2, sort: false, maxWidth: 200 },
            { title: 'type', space: 1, sort: false },
            ...(isDetail ? [] : [{ title: 'etc', space: 1, sort: false }]),
        ];
        // useMemo에서 반환
        return { headTitleList, tableReadDataKeys };
    }, []);
    (0, react_1.useEffect)(() => {
        if (!isDetail || (isDesktop && isModify)) {
            // Use Set for efficient lookups
            const testDataMap = new Map(testData.map(i => [i.id, i.type]));
            // Find the first item in initItem that matches the 'background' type
            const filterBack = initItem.filter(item => testDataMap.get(item) === 'background');
            setBackground(filterBack);
            setItem(initItem);
        }
    }, [testData, initItem, isDetail, isModify]);
    const { data, refetch } = (0, server_1.useContents)({
        id: initItem,
        offset: page === 0 ? 0 : page * count,
        limit: count,
        status: ['converted', 'uploaded'],
        orderby: ['creation_time desc'],
    });
    const refetchList = (0, throttle_1.default)(refetch, 1000, { leading: true, trailing: false });
    (0, react_1.useEffect)(() => {
        if (isUploading)
            return;
        if (initItem && initItem.length > 0) {
            refetchList();
        }
        else {
            setTestData([]);
            setTotalCount(0);
        }
    }, [initItem, page, isUploading]);
    (0, react_1.useEffect)(() => {
        if (data) {
            const { total_count, found_count, items } = data;
            if (total_count > 0 && found_count === 0) {
                const maxPage = Math.max(0, Math.ceil(total_count / 10) - 1);
                setPage(maxPage);
                return;
            }
            if (total_count > 0) {
                setTestData(items);
                setTotalCount(total_count);
                return;
            }
        }
        setTestData([]);
        setTotalCount(0);
    }, [data]);
    //학습자료 불러오기 가져오기 버튼 클릭 시 POPUP
    const openClassDataAdd = () => {
        APP.eventManager.publish(popup_1.TOGGLE_POPUP, {
            component: ContentTable_1.ContentTable,
            componentProps: {
                isReserve: true,
                defaultCheckList: initItem,
                setUpdateCheckList: setItem,
                isPopUp: true,
                typeList: mode === 'mock_test'
                    ? ['background']
                    : ['document', 'video'],
            },
            width: 757,
            title: t('conference.loadClassesData'),
        });
    };
    const renderTitle = (0, react_1.useMemo)(() => (react_1.default.createElement(TestSetting_1.TestSetting, { tableName: t('conference.dataSetting') }, !isDetail && (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(AttachContentButton_1.AttachContentButton, { menu: mode === 'mock_test' && background.length === 0 ? 'background' : 'all', isReserve: true, setUpdateCheckList: setItem, setIsUploading: setIsUploading, isMockTest: mode === 'mock_test' }),
        react_1.default.createElement(common_1.Button, { className: "btn_default sm", text: t('conference.classDataEnroll'), onClick: openClassDataAdd }))))), [testData, isDetail, openClassDataAdd, mode, background]);
    const renderItem = (item, styles) => {
        return tableReadDataKeys.map(headItem => (react_1.default.createElement("div", { key: headItem.title, style: {
                flex: !isMobile && headItem.space,
                maxWidth: headItem?.maxWidth,
                ...styles?.bodyItem,
                overflow: 'hidden',
            } }, headItem.title === 'etc' ? (
        // @ts-ignore
        react_1.default.createElement("p", { className: "underbar_line", onClick: () => setItem(prev => prev.filter(i => i !== item.id)) }, t('common.delete'))) : headItem.title === 'link' ? (react_1.default.createElement("p", { className: "overText2", style: { maxWidth: isMobile ? '150px' : 'unset' } }, item.name)) : headItem.title === 'type' ? (react_1.default.createElement("p", { className: "overText2" }, t(`supportRoom.${item.type}`))) : (react_1.default.createElement("p", { className: "overText2" }, item[headItem.title])))));
    };
    const renderEmpty = (0, react_1.useMemo)(() => (react_1.default.createElement("div", { className: "empty_data", style: { color: Colors_1.Colors.light_grey } },
        react_1.default.createElement(common_1.Icon, { icon: "detail-delete", size: 36, fill: Colors_1.Colors.w_grey }),
        react_1.default.createElement("p", null, t('supportRoom.contentsEmpty')))), []);
    const handlerMoreData = (page) => {
        setPage(page);
    };
    return (react_1.default.createElement(StudySettingStyle, { "$isMobile": isMobile, className: "study-setting-table" },
        react_1.default.createElement(common_1.Table, { className: "live-list-002", showCheckBox: false, showIndex: isMobile ? false : true, indexOrder: "desc", isInfinite: false, data: testData, totalCount: totalCount, page: page, sortDefault: "id", headTitleList: headTitleList, renderTitle: renderTitle, renderItem: renderItem, forceShowheader: isMobile ? false : true, renderEmpty: isDetail && totalCount <= 0 && renderEmpty, handlerMoreData: handlerMoreData, padding: false })));
});
